import { Form, Formik } from "formik";
import "moment-timezone";
import React, { Component } from "react";
import { Button, Modal } from 'react-bootstrap';
import Alert from 'react-s-alert';
import * as Yup from "yup";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from '../utils/DealsService';

class VerifySaleModal extends Component {
  render() {
    const { showModal, onCloseModal, reviewType } = this.props
    const validationSchema = Yup.object().shape({
      notes_verification: Yup.string().max(1000, "maximum 1000 characters")
    });
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Verify {reviewType}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ notes_verification: '', review_type: reviewType, next_action: 'upgrade_call' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { onConfirmModal } = this.props
              const { deal } = this.props
              values['next_action'] = 'complete'
              DealsService.takeAction('verify', deal.id, values).then(data => {
                Alert.success('Completed')
                onConfirmModal(data)
              });
            }}
            render={({
              errors,
              touched,
              isValid,
              isSubmitting,
            }) => (
                <Form>
                  <h4 style={{ marginTop: 0 }}>Have you checked all of the following?</h4>
                  <ol>
                    <li>Check First Session Booked</li>
                    <li>Check Initial Payment Received</li>
                    <li>Check Contract Signed</li>
                    <li>Payment Arrangement Finalized</li>
                    <li>Instalments in Instalments Sheet</li>
                    <li>Basecamp Set Up</li>
                  </ol>

                  <FormikTextAreaControl fieldLabel='Review Notes' fieldName='notes_verification' errors={errors} touched={touched} textareaHeight={200} />

                  <div style={{ marginTop: 20 }}>
                    <Button onClick={onCloseModal} bsSize='small'>Whoops, cancel this</Button>
                    <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='success' bsSize='small'>Sale is Verifed, mark Completed</Button>
                  </div>
                </Form>
              )} />
        </Modal.Body>
      </Modal>)
  }
}

export default VerifySaleModal